<template>
  <app-collapse class="mt-1">
    <app-collapse-item
      :is-visible="false"
      class="collapsible-section-bg"
      title="Additions and deductions, costs subject to VAT"
    >
      <template #header>
        <span
          class="lead collapse-title"
        >
          <section-status-icon
            :has-data="hasAdditionsDeductionsData"
            :has-errors="item.issues && item.issues.length > 0"
          />
          Additions and deductions, costs subject to VAT
        </span>
      </template>
      <div
        v-for="(entry, entryIndex) in item.additions_deductions"
        :key="entryIndex"
        class="border rounded pl-3 pr-3 pt-1 mb-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="3"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Code"
              rules=""
            >
              <b-form-group>
                <label>
                  Code <small class="text-muted">1404008000</small>
                  <feather-icon
                    v-b-tooltip.hover.top="'Type of addition or deduction'"
                    icon="InfoIcon"
                    size="14"
                    class="ml-50 text-muted"
                  />
                </label>
                <classifier-select
                  v-model="entry.code"
                  :classifier-key="classifierKeys.additionDeductionCodes"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="3"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Amount"
              rules=""
            >
              <b-form-group>
                <label>
                  Amount <small class="text-muted">1404014000</small>
                </label>
                <b-form-input
                  v-model="entry.amount"
                  type="number"
                  step="0.01"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="2"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Currency"
              rules=""
            >
              <b-form-group>
                <label>
                  Currency <small class="text-muted">140400000B</small>
                </label>
                <classifier-select
                  v-model="entry.currency"
                  :classifier-key="classifierKeys.currencies"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="4"
            class="text-right"
          >
            <b-button
              v-if="!disabled"
              variant="link"
              size="sm"
              class="text-danger mt-2"
              @click="removeEntry(entryIndex)"
            >
              <feather-icon icon="TrashIcon" />
              Delete
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col class="text-right">
          <b-button
            v-if="!disabled"
            variant="info"
            size="sm"
            @click="addEntry"
          >
            <feather-icon icon="PlusIcon" />
            New row
          </b-button>
        </b-col>
      </b-row>
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import SectionStatusIcon from '@/views/shipments/declarations/modals/components/h1/SectionStatusIcon.vue'
import ClassifierSelect from '@/views/components/ClassifierSelect.vue'
import { CUSTOMS_CLASSIFIER_KEYS } from '@/libs/customsClassifiers'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    SectionStatusIcon,
    ClassifierSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { classifierKeys: CUSTOMS_CLASSIFIER_KEYS }
  },
  computed: {
    hasAdditionsDeductionsData() {
      if (!this.item || !this.item.goods_data || !this.item.additions_deductions || !Array.isArray(this.item.additions_deductions)) {
        return false
      }
      return this.item.additions_deductions.some(entry => entry.code || entry.amount || entry.currency)
    },
  },
  methods: {
    addEntry() {
      if (!this.item.additions_deductions) {
        this.$set(this.item.goods_data, 'additions_deductions', [])
      }
      this.item.additions_deductions.push({
        code: '',
        amount: '',
        currency: '',
      })
    },
    removeEntry(entryIndex) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this addition/deduction entry?', {
        title: 'Please Confirm',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
      }).then(value => {
        if (value) {
          this.item.additions_deductions.splice(entryIndex, 1)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/base/core/mixins/declarations-mixins';

.collapsible-section-bg {
  @include collapsible-section-bg;
}
</style>
